import React, { Fragment, useState } from "react";
import { Col, Row } from "antd";
import { requests } from "../../../../configs/constants";
import { requestApiUpsellProvider } from "../../../../lib/api/providers";
import PhotoViewer from "../../../../components/photo/Viewer";

import { CreationPdcKeys } from "../Edit.detailpdc";
import { EditAttribute, RetailerEdition, TypologyEdition } from "../../Components/CustomInput.component";
const AWS_URL = "https://s3-eu-west-1.amazonaws.com/surveyefficiencecell/";

const Modification = ({ request, token, returnToList }) => {
  const [updatedData, setUpdatedData] = useState(request.data || {});
  return (
    <div style={{ width: "100%" }}>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <h2 style={{ fontSize: 20, fontWeight: "bold", margin: 20 }}>Demande de modification</h2>
      </div>
      <div style={{ marginLeft: 20 }}>Demande faite par : {request.infos.user_email}</div>
      <Row>
        <Col span={16}>
          <div style={{ width: "100%", margin: 20 }}>
            {Object.entries(CreationPdcKeys)
              .filter(
                ([key, _]) =>
                  key !== "photo_url" &&
                  key !== "pdc_id" &&
                  key !== "typology_id" &&
                  key !== "typology" &&
                  key !== "retailer_id" &&
                  Object.keys(updatedData).indexOf(key) >= 0
              )
              .map(([key, label]) => (
                <Fragment key={key}>
                  {key !== "photo_url" && key !== "pdc_id" && (
                    <Col span={12}>
                      <EditAttribute
                        _key={key}
                        label={label}
                        value={updatedData[key]}
                        handleChange={newValue => {
                          const newData = { ...updatedData, [key]: newValue };
                          setUpdatedData(newData);
                        }}
                      />
                    </Col>
                  )}
                </Fragment>
              ))}
            {Object.entries(updatedData)
              .filter(([key, _]) => key === "typology")
              .map(([key, value]) => (
                <Fragment key={key}>
                  <Col span={12}>
                    <TypologyEdition
                      _key={key}
                      value={value}
                      handleChange={newValue => {
                        const newData = { ...updatedData, typology_id: newValue };
                        setUpdatedData(newData);
                      }}
                    />
                  </Col>
                </Fragment>
              ))}
            {Object.entries(updatedData)
              .filter(([key, _]) => key === "retailer_id")
              .map(([key, value]) => (
                <Fragment key={key}>
                  <Col span={12}>
                    <RetailerEdition
                      retailer_id={value}
                      handleChange={newValue => {
                        const newData = { ...updatedData, retailer_id: newValue };
                        setUpdatedData(newData);
                      }}
                    />
                  </Col>
                </Fragment>
              ))}
          </div>
        </Col>
        <Col span={8}>
          {Object.entries(request.data)
            .filter(([key, _]) => key === "photo_url")
            .map(([key, value]) => (
              <div
                key={key}
                style={{
                  margin: 5
                }}
              >
                <div style={{ fontWeight: "bold", marginBottom: 5 }}>Proposition de photo </div>
                <PhotoViewer style={{ maxHeight: 200 }} url={AWS_URL + value} />
              </div>
            ))}
        </Col>
      </Row>
      <Row>
        <div style={{ display: "flex", justifyContent: "flex-end", margin: 20 }}>
          <div
            className="p-btn p-btn-red"
            style={{ marginRight: 20 }}
            onClick={async () => {
              await requestApiUpsellProvider.post(
                "/reject",
                { _id: request._id, type: requests.PDC_UPDATE },
                {
                  headers: {
                    Authorization: token
                  }
                }
              );
              returnToList();
            }}
          >
            Refuser
          </div>
          <div
            className="p-btn p-btn-green"
            onClick={async () => {
              await requestApiUpsellProvider.post(
                "/validate",
                { _id: request._id, type: requests.PDC_UPDATE, data: updatedData },
                {
                  headers: {
                    Authorization: token
                  }
                }
              );
              returnToList();
            }}
          >
            Valider
          </div>
        </div>
      </Row>
    </div>
  );
};

export default Modification;



// WEBPACK FOOTER //
// src/pages/basepdc/detailPdc/Request.js/Modification.request.js